const theme = {
  id: "dark",
  primaryColor: "#8B9A46",
  secondaryColor: "#541212",
  bodyBackgroundColor: "#8B9A46",
  bodyFontColor: "#EEEEEE",
};

export default theme;
